import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d8ec410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "join-meeting-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Join Meeting", -1))
const _hoisted_3 = { class: "meeting-list" }
const _hoisted_4 = ["onClick"]

import { computed, ref, onMounted } from 'vue';

import type { MeetingRoute } from '../types';

interface Meeting {
  description: string;
  meetingId: string;
  route: MeetingRoute;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinExistingMeeting',
  props: {
    meetings: {}
  },
  emits: ["meeting-selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const defaultOption = ref<HTMLElement | null>(null);

const sortedMeetings = computed(() => {
  return [...props.meetings].sort((a, b) => a.description.localeCompare(b.description));
});

const selectMeeting = (meetingId: string, route: MeetingRoute) => {
  console.log('JoinExistingMeeting: selecting meeting with id:', meetingId, 'and route:', route);
  emit('meeting-selected', meetingId, route);
};

onMounted(() => {
  // Focus the "Start New Meeting" option by default
  defaultOption.value?.focus();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "join-meeting-overlay",
    onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (selectMeeting(null, '/chat')), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "meeting-option default-option",
          ref_key: "defaultOption",
          ref: defaultOption,
          tabindex: "0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectMeeting('/chat', '/chat')))
        }, " Start New AI Meeting ", 512),
        _createElementVNode("div", {
          class: "meeting-option",
          tabindex: "0",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectMeeting('/meeting', '/meeting')))
        }, " Start New Group Meeting "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedMeetings.value, (meeting) => {
          return (_openBlock(), _createElementBlock("div", {
            key: meeting.meetingId,
            class: "meeting-option",
            tabindex: "0",
            onClick: ($event: any) => (selectMeeting(meeting.meetingId, meeting.route))
          }, " Join " + _toDisplayString(meeting.description) + "'s Meeting ", 9, _hoisted_4))
        }), 128))
      ])
    ])
  ], 32))
}
}

})